<template lang="pug">
.send-message-read-members-modal
  b-modal(v-model="_value" size="xl" no-close-on-backdrop no-close-on-esc)
    template(#modal-header="{ cancel }")
      .send-message-read-families-modal-header(style="width:100%;")
        .d-flex.justify-content-end.flex-fill
          button.btn(@click="onDownload" type="button") ダウンロード
      button.close(type="button" @click="cancel") ×

    .send-message-read-members-modal-table
      .thead
        .header-line
          .th.type 種類
          .th.group-name グループ名
          .th.member-name ユーザー名
          .th.tel 電話番号
          .th.organization 所属
          .th.read-datetime(v-if="showReadDatetime") 既読日時
      .tbody
        .body-line(v-for="member in otherUsers")
          .td.type {{ member.groupTypeName }}
          .td.group-name {{ member.groupName }}
          .td.member-name {{ member.groupMemberName }}
          .td.tel {{ member.groupMemberTel }}
          .td.organization {{ member.groupMemberOrganization }}
          .td.read-datetime(v-if="showReadDatetime") {{ convertDatetime(member.readDatetime) }}

    template(#modal-footer="{ ok }")
      b-button.btn.modal-ok-btn(@click="ok") 閉じる
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { OtherUserGroupSendMessageReadMemberModel } from "@/commons/services/OtherUserGroupSendMessageReadMembers";

/**
 * ### 施設関係者グループメンバー詳細表示モーダル
 */
@Component
export default class SendMessageOtherUserGroupReadMembersModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;

  /** 表示対象の施設関係者グループメンバー */
  @Prop({ required: true })
  otherUsers!: Array<OtherUserGroupSendMessageReadMemberModel>;

  @Prop()
  csvTypeName!: string;

  @Prop()
  sendMessageTitle!: string;

  @Prop()
  showReadDatetime!: boolean;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  /**
   * ### PDFダウンロードボタン押下イベント
   */
  public async onDownload(): Promise<void> {
    const csv: string = this.createCsv(this.otherUsers);
    this.downloadCsv(csv, `HitomeQコネクト-メッセージ送信-${this.sendMessageTitle}-${this.csvTypeName}.csv`);
    return;
  }

  /**
   * ### イベント申込のCSVを作成する
   */
  public createCsv(otherUsers: Array<OtherUserGroupSendMessageReadMemberModel>): string {
    let csv: string[] = [];
    csv.push("\ufeff" + `種類,グループ名,ユーザー名,電話番号,所属`);

    for (const item of otherUsers) {
      const typeName: string = item.groupTypeName;
      const name: string = item.groupName;
      const memberName: string = item.groupMemberName;
      const memberTel: string = item.groupMemberTel;
      const organization: string = item.groupMemberOrganization;
      csv.push(`${typeName},${name},${memberName},="${memberTel}",${organization}`);
    }

    return csv.join("\n");
  }

  /**
   * ### CSVファイルをダウンロードさせる
   *
   * - CSVの内容からblobファイルを作成する
   * - blobファイルの種別はtext/csv
   * - a要素を作ってそれを疑似的にクリックさせることでダウンロードさせる
   */
  public downloadCsv(csv: string, fileName: string): void {
    const blob: Blob = new Blob([csv], { type: "text/csv" });

    let link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();

    return;
  }

  /**
   * ### 日付を文字列に変換する
   */
  public convertDatetime(datetime: number): string {
    return this.$dateUtil.convertNumberToString(datetime, "yyyy年mm月dd日 hh:MM");
  }
}
</script>
